import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {i18_EDITTERMIN, i18_SIGNUP, i18_TRANSLATION} from "./i18nReferences";

const devLoadPath = 'https://localize.kisscalservice.de/backend/api/v1/system/localize/projects/1/dev/{{ns}}/{{lng}}'
const stagedLoadPath = 'https://localize.kisscalservice.de/backend/api/v1/system/localize/projects/staged/1/90/{{ns}}/{{lng}}'
const isDev = import.meta.env.REACT_APP_ENV === 'development'

// Migrate old localStorage keys to new unified key
const migrateOldLanguageKeys = () => {
    const oldLoginLang = localStorage.getItem('login_language');
    const oldSignupLang = localStorage.getItem('signup_language');
    const newLang = localStorage.getItem('app_language');
    
    if (!newLang && (oldLoginLang || oldSignupLang)) {
        const langToMigrate = oldLoginLang || oldSignupLang;
        localStorage.setItem('app_language', langToMigrate);
        localStorage.removeItem('login_language');
        localStorage.removeItem('signup_language');
    }
};

migrateOldLanguageKeys();

i18n
    .use(initReactI18next)
    .use(HttpApi)
    .use(LanguageDetector)
    .init({
        ns: [i18_TRANSLATION, i18_EDITTERMIN, i18_SIGNUP],
        defaultNS: i18_TRANSLATION,
        supportedLngs: ['de', 'en', 'it', 'fr', 'es', 'pl'],
        load: 'languageOnly',
        debug: (import.meta.env.REACT_APP_ENV === 'development'),
        fallbackLng: 'en',
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'app_language',
            caches: ['localStorage'],
        },
        backend: {
            loadPath: isDev ? devLoadPath : stagedLoadPath,
        },
        interpolation: {escapeValue: false},
        keySeparator: false,
        react: {
            useSuspense: false,
        },
    });

export default i18n;
